import { createReducer, on, Action, createFeatureSelector } from '@ngrx/store';
import * as NetworkLoggerActions from './network-logger.actions';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

export interface NetworkLogEntry {
  id: string;
  url: string;
  method: string;
  requestSize?: number;
  requestTimestamp?: number;
  statusCode?: number;
  responseSize?: number;
  responseTimestamp?: number;
}

export const networkLoggerFeatureKey = 'networkLogger';

export type State = EntityState<NetworkLogEntry>;

export const adapter: EntityAdapter<NetworkLogEntry> = createEntityAdapter<NetworkLogEntry>();

export const initialState: State = adapter.getInitialState({});

export const networkLoggerReducer = createReducer(
  initialState,
  on(NetworkLoggerActions.logNetworkActivity, (state, action) =>
    adapter.upsertOne(action.entry, state)
  ),
  on(NetworkLoggerActions.cleanUpNetworkActivityLogs, (state, { ids }) =>
    adapter.removeMany(ids, state)
  ),
  on(NetworkLoggerActions.clearNetworkActivityLogs, (state) => adapter.removeAll({ ...state }))
);

export function reducer(state: State | undefined, action: Action) {
  return networkLoggerReducer(state, action);
}

export const selectFeature = createFeatureSelector<State>(networkLoggerFeatureKey);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors(selectFeature);
